export default __webpack_public_path__ + "static/media/MihirKhare_headshot.05fe0a16.jpg";